<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <!-- Navbar -->
    <HeaderMenu />
    <!-- End Navbar -->
    <main class="main-content position-relative border-radius-lg ">
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div class="w-60 mx-auto">
          <!-- Recorre los grupos y crea una fila para cada grupo -->
          <template v-for="(grupo, grupoIndex) in esquemasAgrupados" :key="grupoIndex">
            <div class="py-4 px-4" >
              <!-- Título del grupo -->
              <h5 class="mb-3 fw-bolder pb-4" style="color: #fa6c30;">{{ grupo.nombre }}</h5>
              <!-- Fila con los esquemas del grupo -->
              <div class="row">
                <template v-for="(entidad, index) in grupo.esquemas" :key="index">
                  <div class="col-md-3 col-sm-6 mb-4">
                    <FolderCard2 :entidad="entidad"/>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import FolderCard2 from "../components/FolderCard2.vue";
import { onMounted, ref, computed } from "vue";
import axiosInstance from "../axios"; // Usa la instancia de axios que creamos previamente

export default {
  name: "HomeView",
  components: { HeaderMenu, FolderCard2 },
  setup() {
    const esquemas = ref([]);

    // Computed property para agrupar esquemas por grupo
    const esquemasAgrupados = computed(() => {
      const grupos = {};
      
      esquemas.value.forEach(esquema => {
        const grupo = esquema.grupo || 'Sin Grupo';
        if (!grupos[grupo]) {
          grupos[grupo] = [];
        }
        grupos[grupo].push(esquema);
      });
      
      // Convertir a array y ordenar por nombre del grupo
      return Object.keys(grupos)
        .sort()
        .map(grupo => ({
          nombre: grupo,
          esquemas: grupos[grupo]
        }));
    });

    // Función para asignar colores a los esquemas
    const getColorForEsquema = (entidad) => {
      const colors = ['amber', 'blue', 'green', 'red', 'purple', 'indigo'];
      // Usar el ID del esquema para asignar un color consistente
      const colorIndex = entidad.id % colors.length;
      return colors[colorIndex];
    };

    // Realizamos la llamada al backend al cargar el componente
    onMounted(async () => {
      try {
        const response = await axiosInstance.get("/api/esquemas");
        esquemas.value = response.data.esquemas || [];
      } catch (error) {
        console.error("Error al obtener los esquemas", error);
      }
    });

    return {
      esquemas,
      esquemasAgrupados,
      getColorForEsquema,
    };
  },
};
</script>

<style scoped>
/* Estilos que puedas necesitar */
</style>
